import type { IFieldLayout } from './IFieldLayout';

/** Типове розміщення полів платформи (прототип v4 GSET_DEFAULT; те саме засіває сервер у cfg.platform_setting fieldLayout). */
export const layoutDefaults: IFieldLayout = {
  unit: 150,
  groupMin: 480,
  longOption: 16,
  groupOrder: ['Management', 'Links', 'Planning', 'Dates', 'Details', 'Notes'],
  widths: { text: 'M', short: 'S', textarea: 'L', number: 'S', date: 'S', select: 'S', selectLong: 'M', user: 'M', tags: 'L', area: 'M', iteration: 'M' },
};

/** Типи полів у таблиці «Типова ширина за типом поля» (прототип v4 TYPES). */
export const layoutTypes: readonly string[] = ['text', 'short', 'textarea', 'number', 'date', 'select', 'selectLong', 'user', 'tags', 'area', 'iteration'];

/** Межі числових параметрів сітки (прототип v4 і перевірка сервера): одиниця, дві колонки груп від, довгий варіант вибору. */
export const layoutLimits: Record<'unit' | 'groupMin' | 'longOption', [number, number]> = { unit: [110, 240], groupMin: [360, 720], longOption: [6, 40] };
